var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"0","lg":"3"}},[_c('v-navigation-drawer',{class:{'v-navigation-drawer--fixed': _vm.$vuetify.breakpoint.mdAndDown},attrs:{"id":"app-drawer","clipped":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }